import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import { useNav } from '../../hx/useNav';
import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreClient, StoreVacc } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import GxDlgSelectClient from '../../gx/GxDlgSelectClient';
import GxIconButtonLastClient from '../../gx/GxIconButtonLastClient';


const MxActivityVettV = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const size = useWindowSize();
  const [storeClient, setStoreClient] = useSessionStorage('StoreClient', StoreClient);
  const [storeVacc, setStoreVacc] = useSessionStorage('StoreVacc', StoreVacc);
  
  const r_list = React.useRef(null);
  const r_dlg_select_client = React.useRef(null);

  const hasColumnSpecies = () => { return Boolean(localStorage.getItem('MxActivityVettV.addcol_txTypeAnimalSpecies') === '1') };
  const hasColumnBreed = () => { return Boolean(localStorage.getItem('MxActivityVettV.addcol_txTypeAnimalBreed') === '1') };
  const hasColumnStamp = () => { return Boolean(localStorage.getItem('MxActivityVettV.addcol_txStamp') === '1') };
  const hasColumnBranchId = () => { return Boolean(localStorage.getItem('MxActivityVettV.addcol_txBranchId') === '1') };

  React.useEffect(() => {
    clearStore('StoreVacc', storeVacc);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    if (row === null) {
      r_dlg_select_client.current.setIntermediateValues({});
      r_dlg_select_client.current.setOpen(true);
    } else {
      FxLog.infox('MxActivityVettV.openForm', '...row:', row);
      storeClient.inClient = row.original.inClient;
      storeClient.txClient = row.original.txClient;
      storeClient.inAnimal = row.original.animal_inAnimal;
      storeClient.txAnimal = row.original.animal_txAnimal;
      Promise.all([setStoreClient(storeClient)]).then((result) => {
        FxLog.infox('MxActivityVettV.openForm', '...row.original:', row.original);
        storeVacc.inVacc = row.original._id;
        storeVacc.boComm = row.original.hasComm;
        setStoreVacc(storeVacc);
        navTo("animal-vacc-form");
      });
    }
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    try{
    cols.push({ id: id++, Header: "ID", accessor: "_id", show: false });
    cols.push({ id: "inClient", Header: "inClient", accessor: "inClient", show: false });
    cols.push({ id: "inAnimal", Header: "inAnimal", accessor: "inAnimal", show: false });
    cols.push({ id: "txBranchId", Header: trans('field.branch_id'), accessor: "txBranchId", highlight: true, width: '5%', show: hasColumnBranchId() });
    cols.push({ id: id++, Header: trans('field.client'), accessor: "txClient", highlight: true, width: '20%' });
    cols.push({ id: id++, Header: trans('field.patient'), accessor: "animal_txAnimal", highlight: true, width: '10%' });

    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.species'), accessor: "animal_txTypeAnimalSpecies", highlight: true, width: '10%', show: hasColumnSpecies() });
      cols.push({ id: id++, Header: trans('field.breed'), accessor: "animal_txTypeAnimalBreed", highlight: true, width: '10%', show: hasColumnBreed() });
      cols.push({ id: id++, Header: trans('field.date'), accessor: "dtFrom", highlightDate: true, width: '10%' });
      cols.push({ id: id++, Header: trans('field.next'), accessor: row => (FxTable.cellToLocalDate(row["dtNext"])), width: '10%' });
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '40%' });
      cols.push({ id: id++, Header: trans('field.stamp'), accessor: "txStamp", highlight: true, width: '15%', show: hasColumnStamp() });
      cols.push({ id: id++, Header: trans('field.comm_s'), accessor: row => (row["hasComm"]==='1' ? trans('field.yes') : trans('field.no')), width: '5%' });
      
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: trans('field.date'), accessor: row => (FxTable.cellToLocalDate(row["dtFrom"])), width: '10%' });
    }
    
    cols.push({ id: "A", Header: "not_pending", accessor: row => Boolean(row["_inVaccNextSimilar"]), show: false });
    return cols;

    } catch(error) {
      FxLog.errorx('MxActivityVettV.getTableColumns', error)
    }
    return cols;
  }

  const getTooltip = () => {
    let tip = `${trans('field.client')} / ${trans('field.patient')} / ${trans('field.date')} / ${trans('field.ps')}`;
    if (size.isLarge) {
      if (hasColumnBranchId()) tip = tip + `${' / ' + trans('field.branch_id')}`;
      if (hasColumnSpecies()) tip = tip + `${' / ' + trans('field.species')}`;
      if (hasColumnBreed()) tip = tip + `${' / ' + trans('field.breed')}`;
      if (hasColumnStamp()) tip = tip + `${' / ' + trans('field.stamp')}`;
    }

    return tip;
  }

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({ id: 'txBranchId', name: trans('field.branch_id') + " +🔍︎", checked: hasColumnBranchId() ? '1' : '0' });
    cols.push({ id: 'txTypeAnimalSpecies', name: trans('field.patient') + '-' + trans('field.species') + " +🔍︎", checked: hasColumnSpecies() ? '1' : '0' });
    cols.push({ id: 'txTypeAnimalBreed', name: trans('field.patient') + '-' + trans('field.breed') + " +🔍︎", checked: hasColumnBreed() ? '1' : '0' });
    cols.push({ id: 'txStamp', name: trans('field.vacc') + '-' + trans('field.stamp') + " +🔍︎", checked: hasColumnStamp() ? '1' : '0' });
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxActivityVettV.addcol_txBranchId', options.includes('txBranchId') ? '1' : '0');
    localStorage.setItem('MxActivityVettV.addcol_txTypeAnimalSpecies', options.includes('txTypeAnimalSpecies') ? '1' : '0');
    localStorage.setItem('MxActivityVettV.addcol_txTypeAnimalBreed', options.includes('txTypeAnimalBreed') ? '1' : '0');
    localStorage.setItem('MxActivityVettV.addcol_txStamp', options.includes('txStamp') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.activity')}: ${trans('field.vaccs')}`}
        xref={r_list}
        tooltip={getTooltip()}
        fullscreen
        url={`activity/vett/typelist/v`}
        onOpenForm={openForm}
        refColors={['table_cell_color_black|' + trans('field.pending')]}
        columns={getTableColumns()}
        onOptions={optionsSelected}
        optionalColumns={getTableOptionalCols()}
        optionalFromTo={true}
        optionalFromToButtonToday={true}
        optionalFromToButtonNext7Days={true}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <GxIconButtonLastClient theList={r_list} />
          </div>
        }
        speechExternal
      />

      <GxDlgSelectClient xref={r_dlg_select_client} 
        includeAnimal={true}
        onSelect={(row, intermediateValues) => {
          FxLog.infox('MxActivityVettV.return.GxDlgSelectClient', '...row:', row);
          Promise.all([setStoreClient(storeClient)]).then((result) => {
            openForm(null, row);
          });
        }} 
      />

    </div>
  );

}

export default MxActivityVettV;